import { render, staticRenderFns } from "./menus-card.vue?vue&type=template&id=94e389ae"
import script from "./menus-card.vue?vue&type=script&lang=js"
export * from "./menus-card.vue?vue&type=script&lang=js"
import style0 from "./menus-card.vue?vue&type=style&index=0&id=94e389ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports